import { Pane, ThemeProvider } from 'evergreen-ui';
import React, { memo, ReactNode } from 'react';

import { providerAppTheme } from '../evergreen-theme';
import { Footer } from './Footer';
import { Header } from './Header';
import { LeftNavbar } from './LeftNavbar';
import { ProviderSelectionModal } from '../component/ProviderSelectionModal';
import { useApplicationIsInternalAuth } from 'common/component/ApplicationRootContext';
import { NotificationToaster } from 'common';

type StandardLayoutProps = {
    children: ReactNode;
};

export const StandardLayout = memo(({ children }: StandardLayoutProps) => {
    const [showProviderSelectionModal, setShowProviderSelectionModal] = React.useState(false);
    const isInternalAuth = useApplicationIsInternalAuth();
    return (
        <ThemeProvider value={ providerAppTheme }>
            <NotificationToaster/>
            <Pane minHeight='100vh' className="portal-provider-bg"
                  display="flex"
                  flexDirection="column"
            >
                <Header changeProvider={() => setShowProviderSelectionModal(true)}/>
                <Pane className="portal-layout-main"
                      flexGrow={1}
                      display="flex"
                >
                    <LeftNavbar currentSelection='Client Placement'/>
                    <Pane className="portal-layout-main-content"
                          flexGrow={1}
                          overflow="auto"
                          display="flex"
                          flexDirection="column"
                    >
                        { children }
                        <Footer/>
                    </Pane>
                </Pane>
            </Pane>
            {
                isInternalAuth && <ProviderSelectionModal visible={showProviderSelectionModal} onClose={() => setShowProviderSelectionModal(false)}/>
            }
            </ThemeProvider>
    );
});
